import React from "react";


import { connect } from "react-redux";
import history from "../../auth/history";
import './MonthlyTransaction.css';






class MonthlyTransaction extends React.Component{
    constructor(props){
        super(props);
        this.state={
			phoneNo: this.props.phone,
			password:'',
			otpRef:'',
			message:''
		}
    }



    componentDidMount(){

     
       
	}
	componentWillUnmount(){
    }



  
    txnHistory=()=>{
		history.push('/transaction-history');
		history.go();
	}
    

    render(){

    return(
           
        <div class="col-12 col-md-6 col-lg-4 order-lg-1">
					<div class="topcard">
						<div class="top-box">
							<button class="lbbtn" onClick={this.txnHistory} type="button">View All</button>
							<i class="ta"></i>
							<p>Monthly Transactions</p>
							<h5>₹ 23,12,984.00</h5>
						</div>
						<div class="more-box">
							<p>Success Transaction: <span class="success">567890</span></p>
							<p>Failed Transaction: <span class="failed">123</span></p>
						</div>
					</div>
				</div>
				
				
				
				
		);
      } 
}

const mapStateToProps = (
	{ errorMessageReduce:{errorMessage,loginErrorMessage},
	 miscReduce:{phone}}
	) => ({
		errorMessage,loginErrorMessage,phone
});

export default connect(mapStateToProps, null)(MonthlyTransaction);
